/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
import * as React from 'react';
export default function <C extends React.ComponentType>(Component: C, displayName: string): C {
  const DeprecatedComponent = React.forwardRef<any, any>((props, ref) => {
    if (__DEV__) {
      console.warn(`We have stabilized the ${displayName} component, so you can drop the "Unstable_" prefix from your imports. We will remove the "Unstable_" exports soon, so please make these changes as soon as possible!`);
    }

    // @ts-expect-error Type '{ ref: ForwardedRef<any>; }' is not assignable to type 'LibraryManagedAttributes<C, {}>'.ts(2322)
    return <Component {...props} ref={ref} />;
  });
  DeprecatedComponent.displayName = 'DeprecatedComponent';
  // @ts-ignore
  return DeprecatedComponent;
}